import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'Trade Program',
        enablerKey: 'isTradeExperienceEnabled',
        href: '/trade/apply/',
        dataTn: 'footer-designer-program',
        formattedMessage: (
            <FormattedMessage
                id="dbl.Footer.primary_links_trade_program"
                defaultMessage="Trade Program"
            />
        ),
    },
];
